import { createSlice } from '@reduxjs/toolkit'
import { generateOtp, verifyOtp, resendOtp } from 'api/otpVerification'
// import { SUCCESS_RESPONSE_LIST } from 'constants/api'

const initialState = {
  loading: false,
  error: "",
  // emailTokenId: '',
  // mobileTokenId: '',
  tokenId: {},
  retiresLeft: {},
  email: '',
  phone: '',
  otpValues: {},
  isEmailVerified: false,
  isMobileVerified: false,
  otpResponse: {},
  aadharOTPResponse: {}
  // otpResponseWithPhone : {}
}

export const otpReducer = createSlice({
  name: 'otpReducer',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload
    },
    setPhone: (state, action) => {
      state.phone = action.payload
    },
    setOtpValues: (state, action) => {
      let key = Object.keys(action.payload)[0]
      state.otpValues[key] = action.payload[key]
    },
    setOtpResponse: (state, action) => {
      let key = Object.keys(action.payload)[0]
      state.otpResponse[key] = action.payload[key]
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateOtp.pending, (state) => {
        state.loading = true
      })
      .addCase(generateOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.tokenId[action.payload.key] = action.payload.token_id;
        state.retiresLeft[action.payload.key] = action?.payload?.retiresLeft
        state.aadharOTPResponse = action?.payload
        state.error = "success"
      })
      .addCase(generateOtp.rejected, (state) => {
        state.loading = false
        state.error = "rejected"
      })
    builder
      .addCase(resendOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.retiresLeft[action.payload.key] = action.payload.retriesLeft;
        state.tokenId[action.payload.key] = action.payload.token_id;
        state.aadharOTPResponse = action?.payload
        state.error = "success"
      })
      .addCase(resendOtp.rejected, (state) => {
        state.loading = false
        state.error = "rejected"
      })
    builder
      .addCase(verifyOtp.pending, (state) => {
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.otpResponse[action.payload.key] = action.payload
        state.error = "success"
      })
      .addCase(verifyOtp.rejected, (state) => {
        state.error = "rejected"
      })
  },
})

// Action creators are generated for each case reducer function
export const { setEmail, setPhone, setOtpValues, setOtpResponse, setOtpResponseWithPhone } = otpReducer.actions

export default otpReducer.reducer